
import Cell from 'vux/src/components/cell/index.vue'
import Group from 'vux/src/components/group/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import {amountUtils} from "../../assets/js/utils";

export default {
directives: {
TransferDom
},
components: {
Cell,
Group,
CellBox,
Flexbox,
FlexboxItem,
XDialog
},
created () {
this.getInfo();
},
methods: {
getInfo(){
let id = this.id;
let shopId = this.shopId;
let uri = '/v1/shop/'+ shopId+"/bill/GET_SHOP_BILL_RECORD_DETAIL";
let params = {
"id":id,
"shopId":shopId
};
let _this = this;
_this.axios.post(uri, params, {
headers: {}
}).then(function (response) {
let data = response.data;
if (data.code != undefined && data.code == 0) {
_this.orderInfo = data.data;
} else {
_this.showHideOnBlur = true;
_this.dialogMsg = data.msg;
}
}).catch(function (response) {
_this.showHideOnBlur = true;
_this.dialogMsg = response.message;
});
},
transform: amountUtils.transform,
showRebateAmount(rebateAmount, subsidyThirdpartyCmmsAmount) {
if(subsidyThirdpartyCmmsAmount && rebateAmount && subsidyThirdpartyCmmsAmount > 0 && rebateAmount > 0){
let resultAmount =  rebateAmount - subsidyThirdpartyCmmsAmount;
if(resultAmount > 0) {
return this.transform(resultAmount);
}
return 0;
}
return this.transform(rebateAmount);
}
},
data () {
return {
dialogMsg: '',
showHideOnBlur:false,
id: this.$route.params.id,
shopId: this.$route.params.shopId,
billNo: 0,
orderInfo: {}
}
},
computed : {
}
}



// WEBPACK FOOTER //
// ./src/components/financial/OrderDetail.vue